// @ts-strict-ignore
import {Placement} from 'common/components/tooltip/types';

export const SORTING_TOOLTIP = {
  text: ({t}) => t(`reports.sorting.tooltip`),
  placement: Placement.Bottom,
};

export const GROUPED_SORTING_TOOLTIP = {
  text: ({t}) => t(`reports.sorting.grouped-sort-tooltip`),
};

export const FLAT_SORTING_TOOLTIP = {
  text: ({t}) => t(`reports.sorting.flat-sort-tooltip`),
};
